(() => {
  if (customElements.get('mdf-welcome-popup')) return;
  customElements.define('mdf-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.preview = this.dataset.preview === 'true';
      this.key = this.preview ? 'mdf-welcome-preview' : 'mdf-welcome';
      const read = (storage,key) => {try{return window[storage].getItem(key)}catch{return null}};
      this.write = (storage,key,value) => {try{window[storage].setItem(key,value)}catch{}};
      this.querySelectorAll('.mdf-welcome-close,.mdf-welcome-later').forEach(button => button.addEventListener('click',()=>this.dialog.close()));
      this.dialog.addEventListener('close',()=>this.write('localStorage',this.key+'-dismissed',String(Date.now())));
      this.querySelector('form').addEventListener('submit',event=>{
        if (this.preview) {event.preventDefault();this.querySelector('.mdf-welcome-status').textContent='Preview only — no email has been submitted. The live form will email your welcome offer.';return;}
        this.write('sessionStorage',this.key+'-submitted','true');
      });
      if (this.querySelector('[data-success]')) {this.write('localStorage',this.key+'-subscribed','true');this.show();return;}
      if (this.querySelector('[data-error]')) {this.show();return;}
      const forced = this.preview && new URLSearchParams(location.search).get('welcome_preview') === '1';
      if (forced) {this.show();return;}
      if (read('localStorage',this.key+'-subscribed')) return;
      const dismissed = Number(read('localStorage',this.key+'-dismissed'));
      if (dismissed && Date.now()-dismissed < 7*86400000) return;
      let started = Number(read('sessionStorage',this.key+'-started'));
      if (!started || !Number.isFinite(started)) {started=Date.now();this.write('sessionStorage',this.key+'-started',String(started));}
      this.timer=setTimeout(()=>this.tryShow(),Math.max(0,30000-(Date.now()-started)));
    }
    tryShow() {
      if (!this.isConnected) return;
      if (document.hidden || Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(el=>el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden') || document.activeElement?.matches('input,textarea,select')) {this.timer=setTimeout(()=>this.tryShow(),1500);return;}
      this.show();
    }
    show() {const image=this.querySelector('img[data-src]');if(image&&!image.src)image.src=image.dataset.src;if(!this.dialog.open)this.dialog.showModal();}
    disconnectedCallback() {clearTimeout(this.timer);}
  });
})();

